import { pushEvent } from '../../client/data-layer';

type SummaryArgs = {
  title: string;
};

type SummaryListArgs = {
  order: number;
} & SummaryArgs;

export const trackExpertToplistSummaryViewed = ({ title }: SummaryArgs) => {
  pushEvent('expertToplistSummaryViewed', { title });
};

export const trackExpertTestSummaryViewed = ({ title }: SummaryArgs) => {
  pushEvent('expertTestSummaryViewed', { title });
};

export const trackExpertCategoryPageViewed = () => {
  pushEvent('expertCategoryPageViewed');
};

export const trackExpertTestPageViewed = () => {
  pushEvent('expertTestPageViewed');
};

export const trackExpertToplistPageViewed = () => {
  pushEvent('expertToplistPageViewed');
};

export const trackExpertGuidePageViewed = () => {
  pushEvent('expertGuidePageViewed');
};

export const trackExpertProfilePageViewed = () => {
  pushEvent('expertProfilePageViewed');
};

export const trackExpertLandingPageViewed = () => {
  pushEvent('expertLandingPageViewed');
};

export const trackExpertTestSummaryClicked = ({ title }: SummaryArgs) => {
  pushEvent('expertTestSummaryClicked', { title });
};

export const trackExpertToplistSummaryClicked = ({ title }: SummaryArgs) => {
  pushEvent('expertToplistSummaryClicked', { title });
};

export const trackExpertToplistSummaryTextExpanded = ({
  title,
}: SummaryArgs) => {
  pushEvent('expertToplistSummaryTextExpanded', { title });
};

export const trackExpertToplistsSummaryViewed = () => {
  pushEvent('expertToplistsSummaryViewed');
};

export const trackExpertToplistsSummaryExpanded = () => {
  pushEvent('expertToplistsSummaryExpanded');
};

export const trackExpertToplistsSummaryClicked = ({
  title,
  order,
}: SummaryListArgs) => {
  pushEvent('expertToplistsSummaryClicked', { title, order });
};
